<script setup>
import { defineProps, defineEmits, computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
    modelValue: { type: Boolean, default: false },
    title: { type: String, required: true },
    description: { type: String, required: true },
    type: { type: String, default: "confirm" },
});

const emit = defineEmits(["update:modelValue", "confirm"]);

const close = () => emit("update:modelValue", false);
const confirm = () => emit("confirm");

const isError = computed(() => props.type === "error");
</script>

<template>
    <v-dialog v-model="props.modelValue" max-width="500">
        <v-card class="bg-white">
            <v-card-title class="fw-medium d-flex align-center gap-2 text-wrap" :class="isError ? 'text-error' : 'text-black'">
                <v-icon v-if="isError" color="error" class="me-2">mdi-alert-circle</v-icon>
                {{ props.title }}
            </v-card-title>

            <v-card-text v-if="props.description" v-html="props.description"></v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn v-if="isError" color="error" variant="flat" @click="close">
                    OK
                </v-btn>
                <template v-else>
                    <v-btn text @click="close">{{ t("common.labels.cancel") }}</v-btn>
                    <v-btn class="text-success" @click="confirm">{{ t("common.labels.confirm") }}</v-btn>
                </template>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
